module.exports = __webpack_public_path__ + "static/njem-group-3555c0fe698d775b4cd3703f91ea77f4.jpg";